const features = [
  {
    id: 0,
    title: "The food is so much tastier",
    owner: "Farm products",
    isNegative: false,
    image: "./img/features/eat-1.png",
    about:
      "Homemade sausage made from meat, salt and spices and sausage from the store are two products so different that they aren't even related",
  },
  {
    id: 1,
    title: "Expired products",
    owner: "Store-bought products",
    isNegative: true,
    image: "./img/features/garbage-1.png",
    about:
      "Due to the large quantity of goods, store employees do not have time to replace goods in a timely manner",
  },
  {
    id: 2,
    title: "Natural products",
    owner: "Farm products",
    isNegative: false,
    image: "./img/features/sprout-1.png",
    about:
      "We supply local organic produce grown without pesticides or chemical fertilizers",
  },
  {
    id: 3,
    title: "Substandard meat",
    owner: "Store-bought products",
    isNegative: true,
    image: "./img/features/no-meat-1.png",
    about:
      "Processed meats that contain excessive amounts of sodium, unhealthy fats, and preservatives",
  },
];

export default features;
